/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import has from"../../../core/has.js";import{Milliseconds as o}from"../../../core/time.js";function r(){const r=has("mapview-essential-goto-duration");return null==r?r:o(r)}export{r as getGoToDuration};
